const MyAllocation = () => import("./views/my-allocation.vue");
import DashboardLayout from "../../../views/Layout/DashboardLayout.vue";

const moduleRoute = {
  path: "/",
  component: DashboardLayout,
  children: [
    {
      path: "/my_private_allocation",
      component: MyAllocation,
      name: "My Allocation",
      meta: {
        groupName: "Private Sale",
      },
    },
  ],
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
